module.exports = __webpack_public_path__ + "static/media/dj.423c4156.svg";